import React, { useEffect, useState } from "react";
import { Navbar, Button, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import {
  BsList,
  BsBoxArrowRight,
  BsBell,
  BsChevronDown,
  BsGlobe,
} from "react-icons/bs";
import { fetchUnreadNotifications } from "../store/features/notification/notificationSlice";

function Header({ toggleSidebar }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const { name, email } = useSelector((state) => state.auth);
  const { unreadCount } = useSelector((state) => state.notifications);

  const handleLogout = () => {
    dispatch(logout(email));
    navigate("/");
  };

  useEffect(() => {
    dispatch(fetchUnreadNotifications());
  }, [dispatch]);

  return (
    <header className="app-header">
      <Navbar bg="white" expand="lg">
        <div className="logo">
          <img src="./logo.png" alt="logo" />
        </div>
        <Button
          onClick={toggleSidebar}
          className="me-2 toggle-sidebar-btn"
          variant="none"
        >
          <BsList size={32} />
        </Button>
        <Navbar.Brand></Navbar.Brand>
        <div className="ms-auto d-flex align-items-center">
          {/* <Dropdown className="me-3">
            <Dropdown.Toggle
              variant="none"
              className="d-flex align-items-center"
            >
              <BsGlobe className="me-1" />
              <span>EN</span>
              <BsChevronDown className="ms-1" size={12} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>EN - English</Dropdown.Item>
              <Dropdown.Item>EU - European</Dropdown.Item>
              <Dropdown.Item>IT - Italian</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          <Button
            variant="light"
            className="p-2 me-3 position-relative rounded-circle"
            style={{ width: 32, height: 32 }}
          >
            <BsBell size={14} style={{ position: "relative", bottom: 4 }} />
            <span
              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
              style={{ fontSize: "0.6rem" }}
            >
              {unreadCount}
            </span>
          </Button>
          <Dropdown show={show} onToggle={() => setShow(!show)}>
            <Dropdown.Toggle
              variant="none"
              className="d-flex align-items-center border-0"
            >
              <div
                className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{ width: 32, height: 32 }}
              >
                {name?.[0] || "U"}
              </div>
              <span className="me-1 d-none d-md-inline">{name}</span>
              <BsChevronDown size={12} />
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Dropdown.Item onClick={handleLogout}>
                <BsBoxArrowRight className="me-2" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Navbar>
    </header>
  );
}

export default Header;
